import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-external-dev",
  "use": "app-icon-external-dev-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app-icon-external-dev\"><g fill-rule=\"evenodd\"><path d=\"M3 2h18a1 1 0 011 1v18a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1zm.5 11v7.5h17V13h-17zm0-9.5v8h17v-8h-17z\" /><path d=\"M12 6h6v1.5h-6zM12 15h6v1.5h-6z\" /><circle cx=\"6.75\" cy=\"6.75\" r=\"1\" /><circle cx=\"6.75\" cy=\"15.75\" r=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol